import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import DietPlanEditor from '@/components/diet/DietPlanEditor';

const STATUS_LABEL = {
  consultation_booked: 'Consultation Booked',
  preparing: 'Preparing',
  ready: 'Ready',
  completed: 'Completed',
};

const STATUS_COLOR = {
  consultation_booked: 'bg-slate-100 text-slate-700 border-slate-200',
  preparing: 'bg-amber-50 text-amber-800 border-amber-200',
  ready: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  completed: 'bg-sans_bone text-sans_ink border-sans_line',
};

const DoctorDietPlans = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const load = () => {
    setLoading(true);
    api.get('/diet/appointments').then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  if (selected) {
    return (
      <div>
        <button onClick={() => { setSelected(null); load(); }} className="sans-label hover:text-sans_ink" data-testid="doctor-diet-back-btn">
          ← All diet consultations
        </button>
        <div className="mt-6">
          <DietPlanEditor appointmentId={selected} onDelivered={() => { setSelected(null); load(); }} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Diet Planning</h1>
      <p className="text-sans_mute mt-2">₹2,900 personalised diet consultations awaiting your care.</p>

      {loading && <div className="mt-8 text-sans_mute">Loading…</div>}
      {!loading && items.length === 0 && (
        <div className="mt-10 border border-sans_line bg-white p-10 text-sans_mute">
          No diet consultations yet. When a patient books the ₹2,900 diet consultation, it will appear here.
        </div>
      )}

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        {items.map((a) => (
          <div key={a.appointment_id} className="border border-sans_line bg-white p-6">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="sans-label mb-2">
                  {new Date(a.slot_datetime).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}
                </div>
                <div className="font-serif text-xl text-sans_ink">{a.user_name}</div>
                <div className="text-xs text-sans_mute mt-1">{a.user_email}</div>
                {a.reason && <div className="mt-3 text-sm text-sans_mute leading-relaxed max-w-md">{a.reason}</div>}
              </div>
              <span className={`text-[10px] uppercase tracking-[0.2em] border px-2.5 py-1 whitespace-nowrap ${STATUS_COLOR[a.plan_status] || STATUS_COLOR.consultation_booked}`}>
                {STATUS_LABEL[a.plan_status] || 'Booked'}
              </span>
            </div>
            <div className="mt-5 flex items-center justify-between">
              <div className="text-xs text-sans_mute">
                {a.plan_updated_at ? `Updated ${new Date(a.plan_updated_at).toLocaleDateString('en-IN', { dateStyle: 'medium' })}` : 'Not started'}
              </div>
              <button
                onClick={() => setSelected(a.appointment_id)}
                data-testid={`open-doctor-diet-${a.appointment_id}`}
                className="text-xs text-sans_ink border border-sans_line px-3 py-2 hover:bg-sans_ink hover:text-sans_bone transition-colors"
              >
                {a.plan_status === 'consultation_booked' ? 'Start plan' : 'Continue plan'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoctorDietPlans;
